import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import DataService from '../../services/data.service';
import { useNavigate } from 'react-router-dom';

export default function PromoChecker() {
  const [showModal, setShowModal] = useState(false);
  const [promoData, setPromoData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Load API when page mounts
  useEffect(() => {
    const loadPromotion = async () => {
      try {
        setLoading(true);
        const res = await DataService.getPromotion();
        const payload = res?.data ?? res;
        const data = payload?.data ?? payload;
        setShowModal(payload?.enabled ?? false);
        setPromoData(data);

        // ✅ Example condition
        if (data && data.enabled === true) {
          setShowModal(true);
        }
      } catch (err) {
        console.error("Failed to load promotion:", err);
      } finally {
        setLoading(false);
      }
    };

    loadPromotion();
  }, []);
  const book = () => {
    setShowModal(false);
    navigate('/book-appointment');
  };

  return (
    <>
      {/* Example Page Content */}
     
      {/* Modal */}
   <Modal
  show={showModal}
  onHide={() => setShowModal(false)}
  centered
  backdrop="static"
  keyboard={false}
>
  <Modal.Header style={{ borderBottom: "none", position: "relative", backgroundColor: promoData?.headerBgColor || promoData?.bgColor || "#ffebf7", }}>
   
  </Modal.Header>

  <Modal.Body
    className="text-center"
    style={{
      backgroundColor: promoData?.bgColor || promoData?.backgroundColor || "#fff",
    }}
  >
     <button
      type="button"
      className="modal-close-x"
      aria-label="Close"
      onClick={() => setShowModal(false)}
    >
      ×
    </button>
    {/* brand */}
    <div className="d-flex align-items-center gap-2 mb-3 justify-content-center">
      <img
        src="images/Logo_salon.svg"
        alt="Divine Blush Beauty Logo"
        className="img-fluid"
        style={{ height: 40, width: 40, objectFit: "contain" }}
      />
      <span
        className="text-uppercase fw-semibold"
        style={{ color: "#ff48b0", letterSpacing: ".06em" }}
      >
        Divine Blush Beauty
      </span>
    </div>

    {/* ====== LAYOUT-DRIVEN CONTENT ====== */}
    {(() => {
      const textColor = promoData?.textColor || "#212529";
      const layout = (promoData?.layout || "image-right").toLowerCase();
      const hasImg = !!promoData?.imageDataUrl;

      const imageBlock = hasImg ? (
        <img
          src={promoData.imageDataUrl}
          alt="Promotion"
          className="img-fluid rounded mb-3"
          style={{ objectFit: promoData?.imageFit || "cover", width: "100%" }}
        />
      ) : null;

      const textBlock = (
        <>
          <h2 style={{ color: textColor }}>{promoData?.header}</h2>
          <p style={{ fontSize: "14px", color: textColor }}>{promoData?.subheader}</p>
        </>
      );

      switch (layout) {
        case "image-left":
          return (
            <div className="row g-3 align-items-center text-start">
              {hasImg && <div className="col-md-6">{imageBlock}</div>}
              <div className={hasImg ? "col-md-6" : "col-12"}>{textBlock}</div>
            </div>
          );
        case "image-right":
          return (
            <div className="row g-3 align-items-center text-start">
              <div className={hasImg ? "col-md-6" : "col-12"}>{textBlock}</div>
              {hasImg && <div className="col-md-6">{imageBlock}</div>}
            </div>
          );
        case "image-top":
          return (
            <div className="d-flex flex-column gap-3">
              {imageBlock}
              {textBlock}
            </div>
          );
        case "image-bottom":
        default:
          return (
            <div className="d-flex flex-column gap-3">
              {textBlock}
              {imageBlock}
            </div>
          );
      }
    })()}

    {/* CTA + footer */}
    <button className="btn btn-primary px-4 py-3 fw-semibold text-uppercase shadow mt-3" onClick={book} >
      MAKE AN APPOINTMENT
    </button>
    {promoData?.footerText && (
      <p className="small mt-3 mb-0 text-secondary">{promoData.footerText}</p>
    )}
  </Modal.Body>
  <Modal.Footer
    style={{
      backgroundColor: promoData?.footerBgColor || promoData?.bgColor || "#ffebf7",
      borderTop: "none",
      justifyContent: "center",
    }}
  ></Modal.Footer>
</Modal>

    </>
  );
}
